import React from 'react';
import { Avatar, Grid, Typography, Box, IconButton, Stack, TextField } from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import { TutorProfile } from '../../services/interfaces';

interface ProfileHeaderProps {
    profile: TutorProfile;
    isEditing: boolean;
    onChange: (field: keyof TutorProfile, value: any) => void;
    onEdit: () => void;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ profile, isEditing, onChange, onEdit }) => {
    return (
        <>
            <Grid item xs={12} sm={4} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
                <Avatar
                    src="" // TODO: Add profile image URL
                    sx={{ width: 120, height: 120, bgcolor: 'primary.main', fontSize: 48 }}
                >
                    {profile.firstName?.charAt(0) || 'T'}
                </Avatar>
            </Grid>

            <Grid item xs={12} sm={8}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <Box sx={{ width: '100%' }}>
                        {isEditing ? (
                            <Stack spacing={2}>
                                <TextField
                                    label="First Name"
                                    value={profile.firstName || ''}
                                    onChange={(e) => onChange('firstName', e.target.value)}
                                    fullWidth
                                    size="small"
                                />
                                <TextField
                                    label="Last Name"
                                    value={profile.lastName || ''}
                                    onChange={(e) => onChange('lastName', e.target.value)}
                                    fullWidth
                                    size="small"
                                />
                                <TextField
                                    label="Title"
                                    value={profile.title || ''}
                                    onChange={(e) => onChange('title', e.target.value)}
                                    fullWidth
                                    size="small"
                                />
                            </Stack>
                        ) : (
                            <>
                                <Typography variant="h4" component="div" gutterBottom>
                                    {profile.firstName} {profile.lastName}
                                </Typography>
                                <Typography variant="h6" color="text.secondary" gutterBottom>
                                    {profile.title || 'Tutor'}
                                </Typography>
                            </>
                        )}
                    </Box>

                    {!isEditing && (
                        <IconButton onClick={onEdit} color="primary" aria-label="edit profile">
                            <EditIcon />
                        </IconButton>
                    )}
                </Box>
            </Grid>
        </>
    );
};

export default ProfileHeader;
